var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "card-body" }, [
      _c("ul", { staticClass: "list-group list-group-horizontal-sm m-t-20" }, [
        _vm.hasFileType
          ? _c("li", { staticClass: "list-group-item" }, [
              _c(
                "select",
                {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.file_type,
                      expression: "file_type"
                    }
                  ],
                  staticClass: "form-control",
                  attrs: { name: "file_type", required: "" },
                  on: {
                    change: function($event) {
                      var $$selectedVal = Array.prototype.filter
                        .call($event.target.options, function(o) {
                          return o.selected
                        })
                        .map(function(o) {
                          var val = "_value" in o ? o._value : o.value
                          return val
                        })
                      _vm.file_type = $event.target.multiple
                        ? $$selectedVal
                        : $$selectedVal[0]
                    }
                  }
                },
                [
                  _c("option", [_vm._v("Select File Type")]),
                  _vm._v(" "),
                  _c("option", { attrs: { value: "PAYE_FORM" } }, [
                    _vm._v(
                      "PAYE Annual Return Form H-1 Properly Filled (Total of Jan. - Dec.)"
                    )
                  ]),
                  _vm._v(" "),
                  _c("option", { attrs: { value: "PAYE" } }, [
                    _vm._v("Evidence of 12 Months Remitance of PAYE")
                  ]),
                  _vm._v(" "),
                  _c("option", { attrs: { value: "DEVELOPMENT_LEVY" } }, [
                    _vm._v("Evidence of Employees Development Levy")
                  ]),
                  _vm._v(" "),
                  _c("option", { attrs: { value: "WITHHOLDING_TAX" } }, [
                    _vm._v("Evidence of Withholding Tax Remitance")
                  ]),
                  _vm._v(" "),
                  _c("option", { attrs: { value: "CONSUMPTION_TAX" } }, [
                    _vm._v(
                      "Evidence of 12 Months Consumption Tax Remitance (Where Applicable)"
                    )
                  ]),
                  _vm._v(" "),
                  _c("option", { attrs: { value: "IMMIGRATION_RETURNS" } }, [
                    _vm._v(
                      "Immigration Returns For Expatriate (Where Applicable)"
                    )
                  ]),
                  _vm._v(" "),
                  _c("option", { attrs: { value: "EXPATRIATE_QUOTA" } }, [
                    _vm._v("Expatriate Quota (Where Applicable)")
                  ])
                ]
              )
            ])
          : _vm._e(),
        _vm._v(" "),
        _c(
          "li",
          { staticClass: "list-group-item" },
          [
            _c(
              "button",
              {
                staticClass: "btn btn-primary",
                attrs: { type: "button", disabled: _vm.isUploadDisabled },
                on: { click: _vm.launchFilePicker }
              },
              [
                _c("i", { staticClass: "fas fa-upload" }),
                _vm._v(" " + _vm._s(_vm.buttonText))
              ]
            ),
            _vm._v(" "),
            _c("input", {
              directives: [{ name: "uploader", rawName: "v-uploader" }],
              ref: "file",
              staticStyle: { display: "none" },
              attrs: { type: "file" }
            }),
            _vm._v(" "),
            _c("file-upload-progress", {
              staticStyle: { "margin-top": "10px" },
              attrs: { progress: _vm.progress }
            }),
            _vm._v(" "),
            _vm.progress || _vm.isFileSelected
              ? _c(
                  "button",
                  {
                    directives: [
                      {
                        name: "tooltip",
                        rawName: "v-tooltip",
                        value: _vm.trans("upload.cancel_upload"),
                        expression: "trans('upload.cancel_upload')"
                      }
                    ],
                    staticClass: "btn btn-danger btn-sm m-t-10",
                    attrs: { type: "button" },
                    on: { click: _vm.cancelUpload }
                  },
                  [_c("i", { staticClass: "fas fa-trash" })]
                )
              : _vm._e()
          ],
          1
        ),
        _vm._v("\n           \n      ")
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-12 col-sm-12 m-t-10" }, [
        _vm._v("\n           \n          "),
        _vm.uploaded_files
          ? _c(
              "ul",
              { staticClass: "list-group list-group-horizontal-sm m-t-20" },
              _vm._l(_vm.uploaded_files, function(uploaded_file) {
                return _c("li", { staticClass: "list-group-item" }, [
                  _c("i", { staticClass: "fas fa-file" }),
                  _vm._v(
                    " \n                  " +
                      _vm._s(uploaded_file.user_file_type) +
                      "  - " +
                      _vm._s(uploaded_file.user_filename) +
                      "\n                  "
                  ),
                  _c(
                    "span",
                    {
                      directives: [
                        {
                          name: "confirm",
                          rawName: "v-confirm",
                          value: { ok: _vm.confirmDelete(uploaded_file) },
                          expression: "{ok: confirmDelete(uploaded_file)}"
                        },
                        {
                          name: "tooltip",
                          rawName: "v-tooltip",
                          value: _vm.trans("general.delete_upload"),
                          expression: "trans('general.delete_upload')"
                        }
                      ],
                      key: uploaded_file.id,
                      staticClass: "btn btn-danger btn-xs"
                    },
                    [_c("i", { staticClass: "feather icon-trash-2" })]
                  )
                ])
              }),
              0
            )
          : _vm._e()
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }